import { AdminDrawer } from "@/components/admin/AdminDrawer";
import "./ProductDrawers.css";

type SupplierProductRequestDrawerProps = {
  open: boolean;
  requestName: string;
  note: string;
  error: string;
  pending: boolean;
  onRequestNameChange: (value: string) => void;
  onNoteChange: (value: string) => void;
  onClose: () => void;
  onSubmit: () => void;
};

const inputStyle: React.CSSProperties = {
  width: "100%",
  padding: "0.625rem 0.75rem",
  background: "var(--login-bg)",
  border: "1px solid var(--login-border)",
  borderRadius: "4px",
  color: "var(--login-text)",
  fontFamily: "'DM Sans', sans-serif",
  fontSize: "0.9375rem",
  boxSizing: "border-box",
};

const labelStyle: React.CSSProperties = {
  fontFamily: "'Barlow Condensed', sans-serif",
  fontWeight: 600,
  fontSize: "0.75rem",
  letterSpacing: "0.06em",
  color: "var(--login-muted)",
};

const btnPrimary: React.CSSProperties = {
  flex: 1,
  padding: "0.75rem",
  background: "var(--login-accent)",
  border: "none",
  borderRadius: "4px",
  color: "#fff",
  fontFamily: "'Barlow Condensed', sans-serif",
  fontWeight: 700,
  fontSize: "1rem",
  letterSpacing: "0.06em",
};

const btnDanger: React.CSSProperties = {
  flex: 1,
  padding: "0.75rem",
  border: "1px solid var(--login-error, #e05353)",
  borderRadius: "4px",
  color: "var(--login-error, #e05353)",
  fontFamily: "'Barlow Condensed', sans-serif",
  fontWeight: 700,
  fontSize: "1rem",
  letterSpacing: "0.06em",
};

export function SupplierProductRequestDrawer({
  open,
  requestName,
  note,
  error,
  pending,
  onRequestNameChange,
  onNoteChange,
  onClose,
  onSubmit,
}: SupplierProductRequestDrawerProps) {
  return (
    <AdminDrawer
      open={open}
      onClose={onClose}
      title="Solicitar Produto"
      visualTreatment="operational-sheet"
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "0.375rem",
          }}
        >
          <label htmlFor="supplier-product-request-name" style={labelStyle}>
            Nome do produto
          </label>
          <input
            id="supplier-product-request-name"
            className="muted-placeholder product-drawer-control"
            style={inputStyle}
            value={requestName}
            onChange={(event) => onRequestNameChange(event.target.value)}
            placeholder="Ex: Tomate italiano graúdo"
          />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "0.375rem",
          }}
        >
          <label htmlFor="supplier-product-request-note" style={labelStyle}>
            Observação
          </label>
          <textarea
            id="supplier-product-request-note"
            className="muted-placeholder product-drawer-control"
            style={{
              ...inputStyle,
              minHeight: "7rem",
              resize: "vertical",
            }}
            value={note}
            onChange={(event) => onNoteChange(event.target.value)}
            placeholder="(Opcional)"
          />
        </div>

        {error ? (
          <p
            role="alert"
            style={{
              margin: 0,
              fontFamily: "'DM Sans', sans-serif",
              fontSize: "0.875rem",
              color: "var(--login-error, #e05353)",
            }}
          >
            {error}
          </p>
        ) : null}

        <div style={{ display: "flex", gap: "0.75rem", marginTop: "0.5rem" }}>
          <button
            className="btn-danger product-drawer-action"
            style={btnDanger}
            onClick={onClose}
            disabled={pending}
          >
            Cancelar
          </button>
          <button
            className="btn-primary product-drawer-action"
            style={btnPrimary}
            onClick={onSubmit}
            disabled={pending}
          >
            Solicitar
          </button>
        </div>
      </div>
    </AdminDrawer>
  );
}
